module.exports = __webpack_public_path__ + "static/media/run_3.399b4f6e.png";